<template>
<div class="page-box">
  <div class="page-content">
    <div class="content-header">
      <vs-button
        v-if="isAuth('wx:larkAppConfig:save')"
        class="add-btn btn box-item"
        style="margin-right: 10px"
        @click="addHandle"
      >新增</vs-button>

      <vs-button
        v-if="isAuth('wx:larkAppConfig:delete')"
        :disabled="selected.length < 1"
        class="mutil-btn "
        @click="deleteHandle()"
      >批量删除</vs-button>
    </div>
    <div class="vs-table-outer">
      <vs-table
        multiple
        v-model="selected"
        :data="listData"
      >
        <template
          slot="thead">
          <vs-th>
            ID
          </vs-th>
          <vs-th>
            机器人名称
          </vs-th>
          <vs-th>
            描述
          </vs-th>
          <vs-th>
            APP ID
          </vs-th>
          <vs-th>
            APP 密钥
          </vs-th>
          <vs-th>
            事件加密密钥
          </vs-th>
          <vs-th>
            事件验签token
          </vs-th>
          <vs-th>
            状态
          </vs-th>
          <vs-th>
            操作
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr
            v-for="(tr, index) in data"
            :key="index"
            :data="tr"
          >
            <vs-td>
              {{tr.id}}
            </vs-td>
            <vs-td>
              {{tr.appName || '-'}}
            </vs-td>
            <vs-td

            >
              {{tr.appDesc || '-'}}
            </vs-td>
            <vs-td

            >
              {{tr.appId}}
            </vs-td>
            <vs-td
              style="max-width: 300px"
            >
              <span class="rap-normal">{{tr.appSecret}}</span>
            </vs-td>
            <vs-td
              style="max-width: 200px"
            >
              <span class="rap-normal">{{tr.eventEncryptKey}}</span>
            </vs-td>
            <vs-td
              style="max-width: 200px"
            >
              <span class="rap-normal">{{tr.eventVerificationToken}}</span>
            </vs-td>
            <vs-td>
              <span
                class="self-tag"
                :style="getStyle(tr)"
              >{{tr.status ? '启用': '禁用' }}</span>
            </vs-td>
            <vs-td>
              <el-button
                v-if="isAuth('wx:larkAppConfig:update')"
                type="text"
                class=""
                @click.stop="editHandle(tr)"
              >修改</el-button>
              <el-button
                v-if="isAuth('wx:larkAppConfig:delete')"
                type="text"
                class="delete-btn"
                @click.stop="deleteHandle(tr.id)"
              >删除</el-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="pagination-outer" v-if="total">
      <div class="paginnation-left">
        <size-change @sizeChange="sizeChange"></size-change>
        <span class="tatol-count">合计 {{total}} 条</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
  <add-lark
      :dialog-show="addDialogShow"
      @close="addDialogShow = false"
      @add-success="addSuccess"
  ></add-lark>
  <edit-lark
      :form-data="currentRow"
      :dialog-show="editDialogShow"
      @close="editDialogShow = false"
      @edit-success="editSuccess"
  ></edit-lark>
  <multiple-delete-dialog
    ref="muldelete"
    :ids="ids"
    @sure-delete="confirmDelete"
  ></multiple-delete-dialog>
</div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import {colorRgba} from "@/utils";
import initData from '@/mixins/initData'
import addLark from '@/components/sys/robitCofig/lark/addLark'
import editLark from '@/components/sys/robitCofig/lark/editLark'
import {deleteLarkConfig} from "@/api/sys/robitConfig/lark";

export default {
  name: 'telegramList',
  components: {
    addLark,
    editLark,
    multipleDeleteDialog,
  },
  mixins: [initData],
  data() {
    return {
      selected: [],
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {},
      red: '#D85E5F',
      green: '#41B883',
      ids: [],
    }
  },
  created() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit() {
      this.url = '/wx/manage/larkAppConfig/list'
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order: 'desc'
      }
      return true
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    getBtnType(row){
      if(row.status){
        return 'success';
      }else {
        return 'danger';
      }
    },
    getStatusText(row){
      if(row.status){
        return '启用';
      }else {
        return '禁用';
      }
    },
    addHandle() {
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
      addSuccess(){
          this.$message({
              message: '添加成功',
              type: 'success'
          });

          setTimeout(() => {
              this.addDialogShow = false;
              this.searchHandle();
          },1000);
      },
    editHandle(row){
      this.currentRow = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
      editSuccess(){
          this.$message({
              message: '编辑成功',
              type: 'success'
          });

          setTimeout(() => {
              this.editDialogShow = false;
            this.searchHandle();
          },1000);
      },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteLarkConfig(
        ids
      ).then((res) => {
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
